export default "__VITE_ASSET__zEljjS01__"